export interface IPatientCaseRejectionReasonAmbulance {
  patientCaseId?: string;
  ambulanceId?: string;
  rrAmbulanceId?: string;
  description?: string;
  patientCase?: any;
  ambulance?: any;
  rejectionReasonAmbulance?: any;
}

export const defaultValue: Readonly<IPatientCaseRejectionReasonAmbulance> = {};
